// extracted by mini-css-extract-plugin
export default {"cellInner":"cellInner__Kzpz+"};